<template>
  <div class="dashboard">


    <div class="row">
        <div class="flex xs12 sm12 lg12">
          <va-card >
           <p  style="font-size: 25px"> {{$t('dashboard.SistemaGestao')}}</p>
                    <hr>
          </va-card>
        </div>
    </div>

     <div class="row">
      
        <div class="flex xs12 sm12 lg3">
          <va-card title="Pressed Button Gradients">
                
                <va-button v-on:click="currentTab = CursosAndamento.componet" :color="CursosAndamento.color" :style="CursosAndamento" :to="CursosAndamento.rota"> {{ $t('gestaocurso.CursosAndamento') }}</va-button>
                <va-button v-on:click="currentTab = GradeCurricular.componet" :color="GradeCurricular.color" :style="GradeCurricular" :to="GradeCurricular.rota"> {{ $t('gestaocurso.GradeCurricular') }}</va-button>
                <va-button v-on:click="currentTab = Cursos.componet" :color="Cursos.color" :style="Cursos" :to="Cursos.rota"> {{ $t('gestaocurso.Cursos') }}</va-button>
                <va-button v-on:click="currentTab = Disciplinas.componet" :color="Disciplinas.color" :style="Disciplinas" :to="Disciplinas.rota"> {{ $t('gestaocurso.Disciplinas') }}</va-button>
               <va-button v-if="false" v-on:click="currentTab = TipoDisciplina.componet" :color="TipoDisciplina.color" :style="TipoDisciplina" :to="TipoDisciplina.rota"> {{ $t('gestaocurso.TipoDisciplina') }}</va-button>
                <va-button v-if="false" v-on:click="currentTab = TipoCurso.componet" :color="TipoCurso.color" :style="TipoCurso" :to="TipoCurso.rota"> {{ $t('gestaocurso.TipoCurso') }}</va-button>
          </va-card>
        </div>

        <div class="flex xs12 sm12 lg9">
          <va-card >
         
          <component 
          v-on:trocar_component="trocar_component"
          v-bind:is="currentTabComponent"  
          ></component>
          </va-card>
        </div>
    </div>

  </div>
</template>

<script>
import cursos from './Cursos'
import disciplinas from './Disciplinas'
import gradecurricular from './Gradecurricular'
import tipodisciplina from './Tipodisciplina'
import tipocurso from './Tipocurso'
import setgradecurricular from './SetGradecurricular.vue'
import cursosandamento from './CursosAndamento.vue'
import polos from './Polos.vue'
import datamateria from './Datamateria.vue'
import addprofessor from './AddProfessor.vue'
import addavaliacao from './AddAvaliacao.vue'
import addofertapergunta from './AddofertaPergunta.vue'


export default {
  name: 'dashboard',
  components: {
   cursos,
   disciplinas,
   gradecurricular,
   tipodisciplina,
   tipocurso,
   setgradecurricular,
   cursosandamento,
   polos,
   datamateria,
   addprofessor,
   addavaliacao,
   addofertapergunta
  },

  data () {
      return {
        CursosAndamento: {
          componet: 'CursosAndamento',
          color:'info',
          'width': '100%',
        }, 
        Cursos: {
          componet: 'Cursos',
          color:'info',
          'width': '100%',
        }, 
        Disciplinas: {
           componet: 'Disciplinas',
          color:'info',
          'width': '100%',
        }, 
        GradeCurricular: {
          componet: 'GradeCurricular',
          color:'info',
          'width': '100%',
        }, 
        TipoDisciplina: {
          componet: 'TipoDisciplina',
          color:'info',
          'width': '100%',
        }, 
        TipoCurso: {
          componet: 'TipoCurso',
          color:'info',
          'min-width': '100%',
        }, 

      currentTab: 'cursosandamento',
     
      }
    },

  computed: {
    verifica_online(){
      this.$router.push({ name: 'login' })
    },
    currentTabComponent () {
      console.log(this.currentTab)
      return  this.currentTab.toLowerCase()

    }
  },

  methods: {
    trocar_component (value) {
    //  alert(value)
      this.currentTab = value
      
    }
 
  },
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }
  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
